// Setear data-theme dark si todos los contenedores de la página son dark
const contents = document.querySelectorAll(".entry-content > *")

//  Si solamente hay un bloque y este es dark, queremos que el header sea dark tambien al hacer scroll, usamos para manejar estilos con full-dark
if(contents.length === 1){
    const dataTheme = contents[0].getAttribute("data-theme");
    if (dataTheme === "darkPro") {
   
        const body = document.querySelector("body");
        const masthead = document.querySelector("#masthead");
        body.classList.add("full-dark");
        masthead.setAttribute("data-theme", "darkPro")

    }
} else {
    // Si solamente el primer bloque tiene theme dark queremos que añada los themes a los elementos que hacen cambiar los estilos, al hacer scroll se resetean como marcan los estilos

    const firstBlock = contents[0];

    if (firstBlock && firstBlock.getAttribute) {
        const dataTheme = firstBlock.getAttribute("data-theme");
  

        if (dataTheme === "darkPro") {
            const body = document.querySelector("body");
            body.classList.add("first-block-dark");

            setTimeout(() => {
                const siteNavigationLeft = document.querySelector("#site-navigation-left");
                const siteNavigationRight = document.querySelector("#site-navigation-right");

                if (siteNavigationLeft) siteNavigationLeft.setAttribute("data-theme", "");
                if (siteNavigationRight) siteNavigationRight.setAttribute("data-theme", "");
            }, 1000);
        }
    } else {
        console.warn("⚠️ No se encontró el primer bloque o no tiene atributo data-theme:", contents);
    }
    
}
    
    


